// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"6b145047","311":"3a206970","468":"b4facfe6"}[chunkId] + ".chunk.js";
};